var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-col',{attrs:{"align":"center"}},[_c('v-img',{attrs:{"src":("" + (_vm.playerInfo.image)),"height":"125px","max-width":"125px"}}),_c('v-row',[_c('v-container',[_vm._v(_vm._s(_vm.playerInfo.player))])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }